import { render } from "./FilterNumber.vue?vue&type=template&id=e0fd1aaa"
import script from "./FilterNumber.vue?vue&type=script&lang=js"
export * from "./FilterNumber.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__